<template>
  <BaseModal
    :show="show"
    modal-id="requirements-modal"
    size="lg"
    @close="$emit('close')"
  >
    <template #header>
      <h5 class="modal-title text-white">
        <iconify-icon icon="lucide:file-check" style="margin-right: 8px;" />
        Requisitos del Curso
      </h5>
    </template>

    <template #default>
      <!-- Texto de requisitos -->
      <div v-if="requires" class="mb-4">
        <h6 class="fw-bold mb-2">Requisitos</h6>
        <div class="requires-text" v-html="formatText(requires)"></div>
      </div>

      <!-- Archivos subidos por el usuario -->
      <div v-if="filesUser.length > 0" class="mb-4">
        <h6 class="fw-bold mb-2">Archivos enviados</h6>
        <ul class="list-group">
          <li
            v-for="file in filesUser"
            :key="file.id"
            class="list-group-item d-flex justify-content-between align-items-center"
          >
            <a :href="file.url" target="_blank" rel="noopener noreferrer">
              <iconify-icon icon="lucide:paperclip" style="margin-right: 6px;" />
              {{ file.name || 'Archivo' }}
            </a>
            <button
              class="btn btn-sm btn-outline-danger"
              @click.prevent="$emit('delete-file', file.id)"
            >
              <iconify-icon icon="lucide:trash-2" />
            </button>
          </li>
        </ul>
      </div>

      <!-- FilePond para subir archivos (solo cuando aún no aprobado) -->
      <div v-if="idTypeStatus !== 3" class="mb-3">
        <h6 class="fw-bold mb-2">Adjuntar documentos</h6>
        <file-pond
          ref="filePond"
          name="file"
          label-idle='<span class="filepond--label-action">Arrastra archivos aquí o haz clic para seleccionar</span>'
          allow-multiple
          :allow-reorder="true"
          accepted-file-types="image/jpeg, image/png, application/pdf"
        />
      </div>
    </template>

    <template #footer>
      <button class="btn btn-secondary" @click.prevent="$emit('close')">
        Cerrar
      </button>
      <button
        v-if="idTypeStatus !== 3 && filesUser.length === 0"
        class="btn btn-golden"
        @click.prevent="$emit('postulate-with-requires')"
      >
        Postularme y subir documentos
      </button>
      <button
        v-if="idTypeStatus !== 3 && filesUser.length > 0"
        class="btn btn-golden"
        @click.prevent="$emit('upload-files')"
      >
        <iconify-icon icon="lucide:upload" style="margin-right: 6px;" />
        Enviar documentos
      </button>
    </template>
  </BaseModal>
</template>

<script setup>
import { ref } from 'vue';
import vueFilePond from 'vue-filepond';
import 'filepond/dist/filepond.min.css';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
import BaseModal from '@/components/common/BaseModal.vue';

const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview
);

defineProps({
  show: {
    type: Boolean,
    default: false,
  },
  requires: {
    type: String,
    default: '',
  },
  filesUser: {
    type: Array,
    default: () => [],
  },
  idTypeStatus: {
    type: Number,
    default: 0,
  },
  urlFile: {
    type: [Array, String],
    default: () => [],
  },
});

defineEmits(['close', 'delete-file', 'upload-files', 'postulate-with-requires', 'update:urlFile']);

const filePond = ref(null);

const formatText = (text) => {
  if (!text) return '';
  return text.replace(/(\r\n|\n|\r)/g, '<br>');
};

defineExpose({ filePond });
</script>

<style scoped>
.requires-text {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 12px 16px;
  font-size: 0.95rem;
  color: #333;
  line-height: 1.6;
}

.btn-golden {
  background-color: #b49b57;
  border-color: #b49b57;
  border-radius: 20px;
  padding: 8px 24px;
  font-weight: 600;
  color: #1a1a1a;
  transition: all 0.3s ease;
}

.btn-golden:hover {
  background-color: #d1b25d;
  border-color: #d1b25d;
  color: #1a1a1a;
}
</style>
